/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgTrash: React.FC<React.SVGAttributes<SVGElement>> = (props) => (
    <svg viewBox="0 0 20 20" fill="none" {...props}>
        <path
            d="M3.75 5.167h.781m11.719 0h-.781m0 0l-.721 11.147a1 1 0 01-.998.936h-7.5a1 1 0 01-.998-.936l-.72-11.147m10.937 0h-1.563m-9.375 0h1.563m0 0l1.267-1.96a1 1 0 01.84-.457h3.598a1 1 0 01.84.457l1.267 1.96m-7.812 0h7.812M10 8.792v4.833m2.734-4.833l-.39 4.833M7.266 8.792l.39 4.833"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
